export function formatBankAccount(value: string): string {
  const clean = value
    .replace(/[^\dXx-]/g, "")
    .replace(/-/g, "")
    .toUpperCase();

  if (clean.length <= 5) return clean;

  return `${clean.slice(0, -1)}-${clean.slice(-1)}`;
}
